export const visit = (vm, at) => {
vm(require("foundations-components/lang/ja.lyaml"));
at({ "ja": { "placeholder": "\u30D7\u30EC\u30FC\u30B9\u30DB\u30EB\u30C0\u30FC\uFF08\u4EEE\u633F\u5165\uFF09" } });
};